import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

type GetProgramMissionSpecialistReportRequest = {
  programId?: string
  orderBy: string
  limit: number
  sortDescending: boolean
  cursor: number
  startTime?: string
  endTime?: string
}

type GetProgramMissionSpecialistReportResponse = {
  total: number
  breakdown: MissionSpecialistBreakdownItem[]
}

type MissionSpecialistBreakdownItem = {
  operatorId: string
  name: string
  email: string
  avatarUrl?: string
  taskCount?: number
  avgAccuracy: number
  accuracyTrend?: number
  auditedCount?: number
  avgTimePerTask: number
  avgTimePerTaskTrend?: number
  avgAnnotationPerTask?: number
  avgTimePerAnnotation?: number
  avgTimePerAnnotationTrend?: number
}

export const PROGRAM_MISSION_SPECIALIST_REPORT_KEY = 'program-mission-specialist-report'

export function useGetReport({ programId, ...params }: GetProgramMissionSpecialistReportRequest) {
  return useQuery({
    queryKey: [PROGRAM_MISSION_SPECIALIST_REPORT_KEY, programId, params],
    queryFn: async () => {
      const { data } = await apiClient.get<GetProgramMissionSpecialistReportResponse>(
        `/int/v2/program/${programId}/mission-specialists/report`,
        {
          params: { ...params },
        }
      )
      return data
    },
    enabled: Boolean(programId) && Boolean(params.startTime) && Boolean(params.endTime),
  })
}
